import React from 'react';

import Hero from 'root/client/components/hero/hero';
import Layout from 'root/client/components/layout/layout';

import type { RootPage as Props } from './root-page.types';
import ContentBlocks from 'root/client/components/content-blocks/content-blocks';

const RootPage: React.FunctionComponent<Props> = ({ blocks, hero, layout }) => (
  <Layout {...layout}>
    {hero ? <Hero {...hero} /> : null}
    <div className="root-page__section">
      <ContentBlocks {...blocks} />
    </div>
  </Layout>
);

export default RootPage;
